export function setCookie(cName, cValue, min = 5) {
    let date = new Date();
    date.setMinutes(date.getMinutes() + min);
    const expires = "expires=" + date.toUTCString();
    document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
}
